module.exports = __webpack_public_path__ + "static/dashboard-concept-6f8653090af94768e3664610a5762de8.png";